module.exports = __webpack_public_path__ + "de892601976ec84b1af938725be298f1.MP3";